import { apiPost } from '@/composables/useApi'

export function fetchPartnerSummary() {
  return apiPost('/api/partner/summary', {})
}

export function applyPartner(form) {
  return apiPost('/api/partner/apply', form)
}

export function savePartnerPayoutInfo(form) {
  return apiPost('/api/partner/payout-info', form)
}

export function fetchAdminSession() {
  return apiPost('/api/admin/session', {})
}

export function fetchAdminPartners() {
  return apiPost('/api/admin/partners', {})
}

export function fetchAdminPartnerDetail(uid) {
  return apiPost('/api/admin/partners/detail', { uid })
}

export function runAdminPartnerAction(uid, action, payload = {}) {
  return apiPost('/api/admin/partners/action', { uid, action, ...payload })
}

// 金额以 Stripe 最小货币单位存储（美分），显示时换算
export function formatMoney(amount, currency, locale) {
  if (!currency) return '—'
  return new Intl.NumberFormat(locale, { style: 'currency', currency: currency.toUpperCase() }).format(amount / 100)
}

export function formatDate(value, locale) {
  if (!value) return '—'
  return new Date(value).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' })
}
